import { Component, OnInit ,ViewChild } from '@angular/core';
import { MyserviceService } from '../../provider/myservice.service';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { import_invoice_lang } from "../../language/import_invoice";

@Component({
  selector: 'app-import-fee',
  templateUrl: './import-fee.component.html',
  styleUrls: ['./import-fee.component.scss']
})
export class ImportFeeComponent implements OnInit {
  lang=localStorage.getItem('lang')=="EN"?"EN":"TH";
  language:any;
  municipality_id;
  showPage=false;
  showSave=false;
  isLoading=true;
  file:any;
  excel_invoices:any[] = [];
  constructor(private route:ActivatedRoute,router:Router,private service:MyserviceService) 
  {
    this.language=import_invoice_lang[this.lang];
   }

   ngOnInit() {
    this.isLoading=false;
    this.municipality_id=JSON.parse(sessionStorage.getItem('municipality')).municipality_id;
    this.showPage=true;
    this.route.queryParams.subscribe(params => {
      this.lang= params['lang'];
      if(this.lang!='EN'&&this.lang!='TH'){
        this.lang=localStorage.getItem('lang')=='EN'?'EN':'TH';
        this.language=import_invoice_lang[this.lang];
      }else{
        this.language=import_invoice_lang[this.lang];
        localStorage.setItem('lang',this.lang);
      }
   });
  }

  import_excel()
  {

  }

  download_template()
  {
    let data=[];
    let csvValue=
    {
      invoice_id:'',
      fee_id:'',
      user_id:'',
      create_datetime:'',
      due_date:'',
      fee_price:'',
      vat:'',
      vat_rate:'',
      total_price:'',
      flag:'',
      print_count:'',
      bill_id:'',
      status_code:''
    }							

    data.push(csvValue);
    const replacer = (key, value) => value === null ? '' : value;
    const header = Object.keys(data[0]);
    let csv = data.map(row => header.map(fieldName => JSON.stringify(row[fieldName], replacer)).join(','));
    csv.unshift(header.join(','));
    let csvArray = csv.join('\r\n');

    var ab = document.createElement('a');
    var blob = new Blob([csvArray], {type: 'text/csv' }),
    url = window.URL.createObjectURL(blob);

    ab.href = url;
    ab.download = "invoice_master_template.csv";
    ab.click();
    window.URL.revokeObjectURL(url);
    ab.remove();
  }

  onFileChange(e) {
    const file = e.target.files[0];
    let reader = new FileReader();
    console.log(file);
    this.file=file;

    if (this.isValidCSVFile(file)) 
    {
      reader.readAsText(file);
      reader.onload = () => {
        let csvData = reader.result;
        let csvRecordsArray = (<string>csvData).split(/\r\n|\n/);
        let headersRow = this.getHeaderArray(csvRecordsArray);
        
        for (let r=1;r<=csvRecordsArray.length-1;r++) 
        {
          let Value = csvRecordsArray[r].split(',');

          if (Value[0].toString() != "") 
          {
            let csvValue=
            {
              invoice_id:Value[0],
              fee_id:Value[1],
              user_id:Value[2],
              create_datetime:Value[3],
              due_date:Value[4],
              fee_price:Value[5],
              vat:Value[6],
              vat_rate:Value[7],
              total_price:Value[8],
              flag:Value[9],
              print_count:Value[10],
              bill_id:Value[11],
              status_code:Value[12]
            }
  
            this.excel_invoices.push(csvValue)
          }
          
        }

        this.showSave=true;
      };

      reader.onerror = function () {
        console.log('error is occured while reading file!');
      };
    }
    else {

    }
  
  }

  isValidCSVFile(file: any) {
    return file.name.endsWith(".csv");
  }

  getHeaderArray(csvRecordsArr: any) {
    let headers = (<string>csvRecordsArr[0]).split(',');
    let headerArray = [];
    for (let j = 0; j < headers.length; j++) {
      headerArray.push(headers[j]);
    }
    return headerArray;
  }


  clear() {
    this.excel_invoices = [];
  }

  save()
  {
    if (this.excel_invoices.length > 0) 
    {
      Swal.fire({
        title: this.language.approve_title,
        text: this.language.approve_detail,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.language.confirm,
        cancelButtonText: this.language.cancel
      }).then((result) => {
        if (result.value) {
          this.showPage=false;
          this.isLoading=true;
          this.service.postData({invoice:this.excel_invoices}, "import/import-invoice").then((result:any) => {
            //debugger;
            if(!result.code){
              Swal.fire({
                    title: this.language.save,
                    text: '',
                    type: 'success',
                    showCancelButton: false,
                    showConfirmButton: false,
                    timer:2000
              }).then((Swal_result) => {
                 window.location.reload(); 
              })
            } else {
              Swal.fire({
                title: this.language.inform_titlee,
                text: this.language.inform_detaill,
                type: "warning",
                showCancelButton: false,
                confirmButtonColor: "#3085d6",
                confirmButtonText: this.language.confirm,
              }).then(() => {
                // this.$router.push('/import_invoice');
              });
                          
            }
          },
          (err) => {
            Swal.fire({
              title: this.language.inform_title,
              text: "An error occurred while saving the invoice. Please try again later.",
              type: "warning",
              showCancelButton: false,
              confirmButtonColor: "#3085d6",
              confirmButtonText: this.language.confirm,
            });
          }
          );
        }
      });
    }
    else
    {
      Swal.fire({
        title: this.language.inform_title,
        text: this.language.inform_detail,
        type: 'warning',
        showCancelButton: false,
        confirmButtonColor: '#3085d6',
        confirmButtonText: this.language.confirm
      }).then((result) => {
        if (result.value) {}
      })
    }

  }

}
